import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { EventBusy } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGetAll } from 'services/WService.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};
const useStyles = makeStyles(styles);

const ENTITY = 'logi/inventory-expiring-product';

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Código', accessor: 'ItemCode', width: 120 },
  { Header: 'Producto', accessor: 'ItemName' },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Fecha de vencimiento', accessor: 'fechas_venc', width: 190 },
  { Header: 'Cantidad a vencer', accessor: 'cant_venc', width: 160 },
  { Header: 'Inventario', accessor: 'inventory', width: 160 },
  { Header: 'Creado por', accessor: 'createdBy', width: 160 },
  { Header: 'Fecha', accessor: 'created_at', width: 170 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function InventoryExpiringProductList() {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const [rows, setRows] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadRows() {
    setDataLoading(true);
    let response = await wsGetAll(ENTITY);
    setDataLoading(false);
    if (response.success) setRows(response.data);
  }

  useEffect(() => {
    loadRows();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <EventBusy style={{ color: 'white' }} />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Productos por vencer {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Productos por vencer"
              defaultWidth={1100}
              columns={columns}
              data={rows.map((row, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.LOGI_INVENTORIES_DESTROY}>
                        <ButtonDelete entity={ENTITY} id={row.id} reload={loadRows} />
                      </AllowedGuard>
                    </div>
                  ),
                  ItemCode: row.product?.ItemCode,
                  ItemName: row.product?.ItemName,
                  WhsName: row.warehouse?.WhsName,
                  fechas_venc: (() => {
                    const venc = row.source_detail?.expirations || [];
                    if (venc.length > 0) return venc.map((e) => e.fec_corta).join(', ');
                    if (row.source_detail?.fec_corta) return row.source_detail.fec_corta;
                    return '-';
                  })(),
                  cant_venc: (() => {
                    const venc = row.source_detail?.expirations || [];
                    if (venc.length > 0) return venc.map((e) => e.cant_prod_corta).join(', ');
                    if (row.source_detail?.fec_corta) return `${row.source_detail.cant_prod_corta ?? 0}`;
                    return '-';
                  })(),
                  inventory: row.inventory
                    ? `#${row.inventory.id} (${row.inventory.state})`
                    : `#${row.logi_inventory_id}`,
                  createdBy: row.created_by?.name ?? '-',
                  created_at: row.created_at,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
